export default __webpack_public_path__ + "static/media/allocateStudents1.cdb22de0.png";